import React from "react";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG005 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG005.rendered", props);

    if ( !props.template ) return null;

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="upper-footer">
                    <div className="container">
                        <div className="row">
                            <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG005, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG005.memo", { prevProps, nextProps });
    return true;
});

export default Component;
